var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"home"}},[_c('div',{staticStyle:{"position":"relative","height":"380px"}},[_c('globe-rotate'),_vm._v(" "),_c('div',{staticClass:"mask",staticStyle:{"background":"rgba(0,0,0,.3)"}},[_c('self-introduction')],1)],1),_vm._v(" "),_c('timeline',{attrs:{"list":_vm.timeline.itemList,"title":_vm.timeline.title}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47bf5ee0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 